module.exports = __webpack_public_path__ + "img/019.fa536268.png";